<h2 mat-dialog-title>Preview Email Template</h2>
<mat-dialog-content>
    <div [formGroup]="form">
        <mat-form-field appearance="outline">
            <mat-label>To</mat-label>
            <input matInput formControlName="to" />
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="subject" />
        </mat-form-field>

        <mat-tab-group>
            <mat-tab label="Email Preview">
                <br />
                <div class="mat-mdc-text-field-wrapper mdc-text-field mdc-text-field--outlined">
                    <!--container-->
                    <div class="mat-mdc-form-field-flex">
                        <div
                            matformfieldnotchedoutline=""
                            class="mdc-notched-outline mdc-notched-outline--notched mdc-notched-outline--upgraded"
                            ng-reflect-open="true"
                        >
                            <div class="mat-mdc-notch-piece mdc-notched-outline__leading"></div>
                            <div class="mat-mdc-notch-piece mdc-notched-outline__trailing"></div>
                        </div>
                        <div class="mat-mdc-form-field-infix">
                            <div
                                matinput=""
                                class="mat-mdc-input-element ng-untouched ng-pristine ng-valid mat-mdc-form-field-textarea-control mat-mdc-form-field-input-control mdc-text-field__input cdk-text-field-autofill-monitored"
                                aria-invalid="false"
                                aria-required="false"
                            >
                                <div class="ProseMirror" [innerHTML]="renderResponse?.data | safeHtml"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Template"
                ><br />
                <mat-form-field appearance="outline">
                    <textarea matInput rows="15" formControlName="template"></textarea>
                </mat-form-field>
            </mat-tab>

            <mat-tab label="Model"
                ><br />
                <mat-form-field appearance="outline">
                    <mat-label>Model</mat-label>
                    <textarea matInput rows="15" formControlName="model"></textarea>
                </mat-form-field>
            </mat-tab>

            <mat-tab label="Render Output"
                ><br />
                <mat-form-field appearance="outline">
                    <textarea matInput rows="15" formControlName="render"></textarea>
                </mat-form-field>
            </mat-tab>
        </mat-tab-group>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    <button mat-raised-button (click)="onRender()">Render</button>
    <button mat-raised-button (click)="onSend()" [disabled]="form.invalid" cdkFocusInitial>
        <mat-icon>send</mat-icon> Send
    </button>
</mat-dialog-actions>
